import { render, staticRenderFns } from "./MenuDesktopCollapseItem.vue?vue&type=template&id=bd85a756&scoped=true"
import script from "./MenuDesktopCollapseItem.vue?vue&type=script&lang=js"
export * from "./MenuDesktopCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./MenuDesktopCollapseItem.vue?vue&type=style&index=0&id=bd85a756&prod&scoped=true&lang=css"
import style1 from "./MenuDesktopCollapseItem.vue?vue&type=style&index=1&id=bd85a756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd85a756",
  null
  
)

export default component.exports